exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 440px){.order-pagination .el-pagination__sizes{display:none !important}.order-pagination .el-pagination__jump{display:none !important}}", ""]);

// exports
